// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".staticNotify[data-v-2bf713e7] {\n  padding: 20px 0;\n  border: 1px solid;\n}\n.staticNotify .vc[data-v-2bf713e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.staticNotify .left[data-v-2bf713e7] {\n  width: 50px;\n  text-align: center;\n}\n.staticNotify .right[data-v-2bf713e7] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  line-height: 1.5;\n}", ""]);
// Exports
module.exports = exports;
